// extracted by mini-css-extract-plugin
export var printerCard = "_ci-1";
export var printerCardConfigured = "_ci-2";
export var printerCardError = "_ci-3";
export var printerCardsContainer = "_ci-0";
export var printerIcon = "_ci-8";
export var printerIconConfigured = "_ci-5";
export var printerIconContainer = "_ci-4";
export var printerIconError = "_ci-6";
export var printerIconUnconfigured = "_ci-7";
export var workstationsTableCard = "_ci-9";